import { tns } from 'tiny-slider/src/tiny-slider';

class ImageGallerySlider {
	constructor(el, prevButton, nextButton, nav) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.nav = nav;

		const isGridSlider = !!this.el.dataset.sliderColumns;

		if (isGridSlider) {
			return this.initGridSlider();
		}

		return this.initFullSlider();
	}

	// format: slider (1-4 columns, columns already pre-chunked into slide-col/slide-item by PHP)
	initGridSlider() {
		const userCols = parseInt(this.el.dataset.sliderColumns || '4', 10);
		const colsDesktop = Math.max(1, Math.min(4, userCols));
		const colsTablet = Math.min(colsDesktop, 2);
		const colsMobile = 1;

		this.el.style.setProperty('--ig-cols-desktop', String(colsDesktop));
		this.el.style.setProperty('--ig-cols-tablet', String(colsTablet));

		this.slider = tns({
			container: this.el,
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: false,
			slideBy: 1,
			items: colsMobile,
			gutter: 40,
			responsive: {
				641: { items: colsTablet },
				1025: { items: colsDesktop }
			}
		});

		this.enableControlsFocus();

		this.slider.events.on('indexChanged', () => this.enableControlsFocus());
		this.slider.events.on('transitionEnd', () => this.enableControlsFocus());

		return this.slider;
	}

	// format: slider-full (single image per slide, full width/height)
	initFullSlider() {
		this.slider = tns({
			container: this.el,
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			nav: true,
			navPosition: 'bottom',
			navContainer: this.nav,
			autoHeight: true
		});

		this.enableControlsFocus();

		this.slider.events.on('indexChanged', () => this.enableControlsFocus());
		this.slider.events.on('transitionEnd', () => this.enableControlsFocus());

		return this.slider;
	}

	enableControlsFocus() {
		setTimeout(() => {
			[this.prevButton, this.nextButton].forEach((button) => {
				if (!button) return;

				button.disabled = false;
				button.removeAttribute('disabled');
				button.removeAttribute('tabindex');
				button.setAttribute('tabindex', '0');
				button.removeAttribute('aria-hidden');
			});
		}, 0);
	}
}

export default ImageGallerySlider;